import { CONTAINER_PADDING_PX, LANDSCAPE_PAPER_WIDTH_PX } from '@modules/documents/helpers/getDocumentConfig.helper';

export const CHANGE_TEMPLATES_ENDPOINT = '/change-templates';
export const CHANGE_TEMPLATES_QUERY_KEY = 'change-templates';
export const CHANGE_TEMPLATE_QUERY_KEY = 'change-template';
export const CHANGE_TEMPLATE_DOCUMENT_QUERY_KEY = 'change-template-document';
export const CHANGE_TEMPLATES_TABLE_ID = 'change-templates-table';
export const CHANGE_TEMPLATE_ASSESSMENTS_TABLE_ID = 'change-template-assessments-table';
export const CHANGE_TEMPLATE_ASSESSMENT_DRAG_TYPE = 'change-template-assessment';
export const CHANGE_TEMPLATE_VERSION_PARAM = 'templateVersion';
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/changeTemplates/configs/changeTemplates.config.ts
export const CHANGE_TEMPLATE_DESCRIPTION_MAX_LENGTH = 10000;
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/changeTemplates/configs/changeTemplates.config.ts
export const CHANGE_TEMPLATE_PAGE_SIZE_MAX = 100;
// WARNING Mirrored in FE/BE - keep in sync. Counterpart: backend/src/changeTemplates/configs/changeTemplates.config.ts
export const CHANGE_TEMPLATE_ASSESSMENTS_MAX = 50;
// A Document page's width with a landscape page, so nothing moves between sections of either orientation.
export const CHANGE_TEMPLATE_DETAILS_MAX_WIDTH_PX = LANDSCAPE_PAPER_WIDTH_PX + CONTAINER_PADDING_PX;
// PROJECTS_UI_MARGIN_TOP minus one 50px row: the list has no filter row.
export const CHANGE_TEMPLATES_UI_MARGIN_TOP = 315;
